import React from 'react';
import { FaDiscord } from 'react-icons/fa';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="py-8 px-8 bg-background text-text shadow-inner">
            <div className="container mx-auto text-center space-y-4">
                <p className="text-lg text-gray-400">
                    Need a middleman for your deal? Visit {' '}
                    <a 
                        href="https://lenny.ie" 
                        className="text-primary underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Lenny
                    </a>{' '}
                    or{' '}
                    <a 
                        href="https://wildismcoins.net/middleman" 
                        className="text-primary underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Wildism
                    </a>.
                </p>
                <div className="flex justify-center space-x-6 mb-4">
                    <a 
                        href="https://discord.gg/scammerlist" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        aria-label="Join BlockHelper on Discord"
                        className="text-primary hover:text-gray-300 transition-colors duration-300"
                    >
                        <FaDiscord size={24} />
                    </a>
                    <a 
                        href="https://discord.com/oauth2/authorize?client_id=1193165627704217710" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        aria-label="Join BlockHelper on Discord"
                        className="text-primary hover:text-gray-300 transition-colors duration-300"
                    >
                        <FaDiscord size={24} />
                    </a>
                </div>
                <p className="text-gray-400 text-sm">
                    &copy; {currentYear} BlockHelper. All rights reserved. | Built by{' '}
                    <a 
                        href="https://lenny.ie" 
                        className="text-primary underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Lenny
                    </a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
